export class MaInsuranceUpdate {
    policyNumber: string;
    crn: string;
    vic: string;
    errors: object;
    out_of_time: boolean;
}
